import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControl, InputLabel, ButtonGroup,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {PrintSharp, RemoveRedEye} from "@mui/icons-material";
import {useLazyAcademicStipendWebReportQuery, useLazySessionResultsWebReportQuery} from "../store/reports/reportsApi";
import copyObject from "../utils/copyObject";
import {useGetFacultiesQuery, useLazyGetGroupsByFacultyQuery} from "../store/faculty/facultyApi";
import {useGetSemestersQuery} from "../store/system/systemApi";

export default function AcademicStipendReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dataRequest] = useLazyAcademicStipendWebReportQuery();
    const [groupsRequest] = useLazyGetGroupsByFacultyQuery();
    const [data, setData] = useState([]);
    const {data: facultiesData} = useGetFacultiesQuery();
    const {data: semestersData} = useGetSemestersQuery();
    const [selectedFacultyId, setSelectedFacultyId] = useState(null);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [selectedSemesterId, setSelectedSemesterId] = useState(null);
    const [groups, setGroups] = useState([]);
    const [financialForm, setFinancialForm] = useState(0);
    const [collectingDate, setCollectingDate] = useState(null);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }
    
    async function loadGroups(facultyId) {
        console.log(facultyId)
        setIsSaving(true);

        const request = {
            facultyId
        };
        console.log(request);

        await groupsRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setGroups(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch((e) => {
            alert('Ошибка');
            setIsSaving(false);
        });
    }

    const loadData = async () => {
        if (collectingDate === null || collectingDate === undefined) {
            alert('Заполните дату сбора')
            return;
        }
        
        if (selectedSemesterId === null || selectedSemesterId === undefined) {
            alert('Выберите семестр');
            return;
        }
        
        setIsSaving(true);

        const request = {
            facultyId: selectedFacultyId === 0 ? null : selectedFacultyId,
            groupId: selectedGroupId === 0 ? null : selectedGroupId,
            financialForm,
            semesterId: selectedSemesterId,
            byDate: collectingDate
        };
        console.log(request);

        await dataRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setData(copyObject(fulfilled.data))
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch((e) => {
            alert('Ошибка');
            setIsSaving(false);
        });
    };
    
    function getPrintableReport() {
        setIsLoading(true);
        // int? facultyId, int? groupId, int semesterId, 
        //         AcademicStipendFinancialForm financialForm, DateTime byDate
        fetch(`/Reports/AcademicStipendPrintableReport?facultyId=${selectedFacultyId ?? 0}&groupId=${selectedGroupId ?? 0}&semesterId=${selectedSemesterId}&financialForm=${financialForm}&byDate=${collectingDate}&fileType=xlsx`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                    "semesterid": localStorage.getItem("selectedSemesterId")
                }
            }).then(response => {
            setIsLoading(false);
            return response.blob();
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            const date = new Date()
            link.setAttribute(
                'download',
                `Стипендии.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Академическая стипендия`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {isSaving ? <CircularProgress /> : <></>}
                            Академическая стипендия
                        </Typography>
                    </Stack>
                    
                    <Stack alignItems={'start'}>
                        <Button href={`/edit-finance-forms`}>Редактировать выплаты</Button>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack direction={'row'} spacing={2} alignItems={'end'} alignContent={'space-between'}>
                                <FormControl fullWidth>
                                    <InputLabel id="faculty-select-label"
                                                size={'small'}>Выберите факультет</InputLabel>
                                    <Select
                                        labelId={'faculty-select-label'}
                                        label={'Выберите факультет'}
                                        size={'small'}
                                        onChange={(event) => {setSelectedFacultyId(parseInt(event.target.value,10)); setSelectedGroupId(null); loadGroups(parseInt(event.target.value,10))}}>
                                        <MenuItem key={0} value={0}>Все</MenuItem>
                                        {facultiesData?.data?.map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth>
                                    <InputLabel id="faculty-select-label" size={'small'}>Группа</InputLabel>
                                    <Select
                                        labelId={'faculty-select-label'}
                                        label={'Группа'}
                                        size={'small'}
                                        onChange={(event) => {setSelectedGroupId(parseInt(event.target.value,10))}}>
                                        <MenuItem value={0}>Все</MenuItem>
                                        {groups?.map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>

                                <FormControl fullWidth>
                                    <InputLabel id="faculty-select-label" size={'small'}>Семестр</InputLabel>
                                    <Select
                                        labelId={'faculty-select-label'}
                                        label={'Семестр'}
                                        size={'small'}
                                        onChange={(event) => {setSelectedSemesterId(parseInt(event.target.value,10))}}>
                                        {semestersData?.data?.map((item) => {
                                            return <MenuItem key={item.value} value={item.key}>{item.value}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Stack>
                            <Stack direction={'row'} spacing={2} alignItems={'end'}>
                                <FormControl fullWidth>
                                    <InputLabel id="faculty-select-label" size={'small'}>Форма финансирования</InputLabel>
                                    <Select
                                        labelId={'faculty-select-label'}
                                        label={'Форма финансирования'}
                                        defaultValue={0}
                                        size={'small'}
                                        onChange={(event) => {setFinancialForm(event.target.value)}}>
                                        <MenuItem key={0} value={0}>Все</MenuItem>
                                        <MenuItem key={1} value={1}>Обучающиеся за счет бюджетных средств</MenuItem>
                                        <MenuItem key={2} value={2}>Обучающиеся за счет бюджетных средств (квота)</MenuItem>
                                    </Select>
                                </FormControl>
                                
                                <Stack>
                                    <Typography fontSize={'small'}>Дата сбора</Typography>
                                    <TextField type={'date'} size={'small'} onChange={(event) => setCollectingDate(event.target.value)}/>
                                </Stack>
                            </Stack>
                            
                            <Stack>
                                <br />
                                <Button variant={'outlined'}
                                        startIcon={isLoading ? <CircularProgress size={15} /> : <PrintSharp />}
                                        onClick={() => {getPrintableReport()}}
                                        disabled={isLoading}>Печать</Button>
                                <ButtonGroup orientation={'vertical'}>
                                    <Button variant={'contained'}
                                        startIcon={isSaving ? <CircularProgress size={15} /> : <RemoveRedEye />}
                                        onClick={loadData}
                                        disabled={isSaving}>Загрузить</Button>
                                </ButtonGroup>
                            </Stack>
                        </CardContent>
                    </Card>

                    {data !== null && data !== undefined && data.length > 0
                        ? <>
                            <Card>
                                <Table size={'small'}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>№ п/п</TableCell>
                                            <TableCell>Факультет</TableCell>
                                            <TableCell align={'center'}>Группа</TableCell>
                                            <TableCell align={'center'}>ФИО обучающегося</TableCell>
                                            <TableCell align={'center'}>Размер стипендии в месяц, руб.</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.sort((l,r) => l.studentFullName > r.studentFullName ? 1 : -1).map((item, index) => {
                                            return <TableRow>
                                                <TableCell>{index+1}</TableCell>
                                                <TableCell>{item.facultyName}</TableCell>
                                                <TableCell align={'center'}>{item.groupName}</TableCell>
                                                <TableCell align={'center'}>{item.studentFullName}</TableCell>
                                                <TableCell align={'center'}>{item.amount}</TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </Card>
                        </>
                        : <>
                            <Typography align={'center'} visibility={!isSaving}>Нет загруженных данных</Typography>
                        </>}
                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
